import isMac from '@/utils/isMac'

export const KEY_CODES = {
  ESCAPE: 27,
  ENTER: 13,
  FORWARD_SLASH: 191,
  PLUS: 187,
  MINUS: 189,
  e: 69
}

export const KB_KEYS = {
  LEFT_ARROW: 'ArrowLeft',
  RIGHT_ARROW: 'ArrowRight',
  ENTER: 'Enter'
}

export const ctrlKeyLabel = isMac ? 'cmd' : 'Ctrl'
